import type { Image3D } from '~/domain/patient/image3d';
import type { Patient } from '~/domain/patient/patient';
import type { RigidRegistration } from '~/domain/patient/rigidRegistration';
import type { DatasetEnvironmentRegistry } from '~/engine/scene/DatasetEnvironmentRegistry';
import {
    fusePair,
    pairEndOf,
    warnFusionRefused,
} from '~/viewportGrid/adapters/engine';
import { seriesInstanceUidOf } from '~/domain/dicom/uids';

/**
 * Fuses `secondary` onto the viewport-grid row whose primary image is
 * `primary`, through `registration` (none for a shared frame of
 * reference), when the frame-of-reference gate the row footer lists its
 * candidates with admits the pair. A refused pair changes nothing and the
 * user is told ({@link warnFusionRefused}). Returns whether the pair was
 * fused.
 */
export function fuseGridRow(
    registry: DatasetEnvironmentRegistry,
    patient: Patient | undefined,
    primary: Image3D,
    secondary: Image3D,
    registration?: RigidRegistration
): boolean {
    const primarySeriesUid = seriesInstanceUidOf(primary.seriesUid);
    const secondarySeriesUid = seriesInstanceUidOf(secondary.seriesUid);
    const fused =
        primarySeriesUid !== undefined &&
        secondarySeriesUid !== undefined &&
        fusePair(
            registry,
            patient,
            primarySeriesUid,
            secondarySeriesUid,
            registration
        );
    if (!fused) {
        warnFusionRefused(pairEndOf(primary), pairEndOf(secondary));
    }
    return fused;
}
